import { render, staticRenderFns } from "./AddCardPage.vue?vue&type=template&id=4a677d08&scoped=true&"
import script from "./AddCardPage.vue?vue&type=script&lang=js&"
export * from "./AddCardPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCardPage.vue?vue&type=style&index=0&id=4a677d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a677d08",
  null
  
)

export default component.exports